import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShieldDoneIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.3225 1.33337C9.07783 1.33337 13.0412 2.69404 13.5658 3.21871C14.0032 3.65604 13.9965 4.00937 13.9658 5.70271C13.9538 6.38137 13.9372 7.30604 13.9372 8.58604C13.9372 13.174 8.6905 14.8154 8.46716 14.8827C8.41983 14.8974 8.37116 14.904 8.3225 14.904C8.27383 14.904 8.22516 14.8974 8.17783 14.8827C7.9545 14.8154 2.70783 13.174 2.70783 8.58604C2.70783 7.30804 2.69116 6.38337 2.67916 5.70471C2.67369 5.40197 2.66898 5.14202 2.66743 4.91675L2.66724 4.66255C2.67296 3.82746 2.75133 3.54671 3.07983 3.21871C3.60316 2.69404 7.5665 1.33337 8.3225 1.33337ZM8.3225 2.33337C7.75716 2.33337 4.1905 3.58937 3.77916 3.93271C3.65783 4.05471 3.65316 4.26671 3.67916 5.68604C3.69116 6.37004 3.70783 7.29937 3.70783 8.58604C3.70783 12.0534 7.5225 13.5927 8.32183 13.876C9.1205 13.5914 12.9372 12.0434 12.9372 8.58604C12.9372 7.29804 12.9538 6.36804 12.9665 5.68404C12.9918 4.26604 12.9872 4.05404 12.8585 3.92604C12.4552 3.58937 8.88783 2.33337 8.3225 2.33337ZM10.8035 6.22637C10.9988 6.42171 10.9988 6.73837 10.8035 6.93371L8.20483 9.53304C8.13016 9.60824 8.03374 9.65699 7.93023 9.67348L7.8515 9.67971C7.71883 9.67971 7.5915 9.62704 7.4975 9.53304L6.23616 8.27037C6.0415 8.07504 6.0415 7.75771 6.23683 7.56304C6.4315 7.36771 6.74883 7.36771 6.94416 7.56304L7.8515 8.47171L10.0968 6.22637C10.2922 6.03104 10.6082 6.03104 10.8035 6.22637Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_2)
  ]))
}
}

})